import $ from 'jquery';
import _ from 'underscore';
import Cache from 'root/cache';
import Util from 'root/module/util';
import Router from 'root/router';
import Constants from 'root/constants';
import Form from 'root/module/form';
import View from 'view/base';

export default View.extend({
    tagName: 'form',
    className: 'feedback-search-form box compact',

    filters: [],
    filters_selected: [],
    user_keys: [],

    filters_multiple: ['rating', 'reporter', 'source', 'page_url', 'portal_visible', 'vote_count', 'watch_list', 'due_date', 'sentiment', 'action_required', 'empty_description'],

    events: {
        'submit'                     : 'searchSubmit',
        'click .reset-search'        : 'resetSearch',
        'click .date-shortcut'       : 'dateShortcut',
        'click .dropdown-filter li'  : 'selectFilter',
        'click .search-del button'   : 'deleteFilter',
        'click .search-val li'       : 'selectFilterOption',
        'input .search-val input'    : 'enterFilterOption',
        'c:input .search-val input'  : 'enterFilterOption',
    },

    dom_handlers: {
        selectAll: function(name) {
            var checkbox = this.$el.find('input[name="' + name + '"]');

            if (checkbox.filter(':checked').length === checkbox.length) {
                checkbox.prop('checked', false);
            } else {
                checkbox.prop('checked', true);
            }
        },

        dateShortcut: function(e) {
            e.preventDefault();

            var shortcut = $(e.currentTarget).data('shortcut');

            var date_from;

            switch (shortcut) {
                case 'today':
                    date_from = Util.now().format('YYYY-MM-DD');
                    break;
                case 'week':
                    date_from = Util.now().day(1).format('YYYY-MM-DD');

                    break;
                case 'month':
                    date_from = Util.now().date(1).format('YYYY-MM-DD');
                    break;
                case 'year':
                    date_from = Util.now().dayOfYear(1).format('YYYY-MM-DD');
                    break;
                case 'year_2':
                    date_from = Util.now().add(-1, 'years').dayOfYear(1).format('YYYY-MM-DD');

                    break;
                default: // all
                    date_from = '';
                    break;
            }

            Form.setData(this.$el, {
                from : date_from
            });
        },

        resetSearch: function(e) {
            e.preventDefault();

            this.page = 1;

            this.$el.find('input[type="text"], input[type="date"]').val('');
            this.$el.find('input[type="checkbox"]').prop('checked', false);

            this.filters_selected = [];
            this.renderFilters();
            this.renderFilterOptions();

            this.$el.submit();

            this.trigger('search_reset');
        },

        searchSubmit: function(e) {
            var form_data = Form.getData(this.$el);
            var search_data;

            var query_string_add = {};
            var query_string_remove = [];

            if (form_data.search) {
                query_string_add.search = form_data.search;
            } else {
                query_string_remove.push('search');
                delete form_data.search;
            }

            if (form_data.from) {
                query_string_add.from = form_data.from;
            } else {
                query_string_remove.push('from');
                delete form_data.from;
            }

            if (form_data.to) {
                query_string_add.to = form_data.to;
            } else {
                query_string_remove.push('to');
                delete form_data.to;
            }

            search_data = _.extend({}, form_data);

            var filter_source          = this.searchFilter('source');
            var filter_rating          = this.searchFilter('rating');
            var filter_reporter        = this.searchFilter('reporter');
            var filter_page_url        = this.searchFilter('page_url');
            var filter_portal_visible  = this.searchFilter('portal_visible');
            var filter_vote_count      = this.searchFilter('vote_count');
            var filter_watch_list      = this.searchFilter('watch_list');
            var filter_due_date        = this.searchFilter('due_date');
            var filter_sentiment       = this.searchFilter('sentiment');
            var filter_action_required = this.searchFilter('action_required');
            var filter_empty_description = this.searchFilter('empty_description');

            if (filter_source && filter_source.val.length && filter_source.val.length < 4) {
                query_string_add.source = filter_source.val;
                search_data.source = filter_source.val;
            } else {
                query_string_remove.push('source');
            }

            if (filter_rating && filter_rating.val.length && filter_rating.val.length < 7) {
                query_string_add.rating = filter_rating.val;
                search_data.rating = filter_rating.val;
            } else {
                query_string_remove.push('rating');
            }

            if (filter_reporter && filter_reporter.val.length) {
                query_string_add.reporter = filter_reporter.val;
                search_data.reporter = filter_reporter.val;
            } else {
                query_string_remove.push('reporter');
            }

            if (filter_page_url && filter_page_url.val.length) {
                query_string_add.page_url = filter_page_url.val;
                search_data.page_url = filter_page_url.val;
            } else {
                query_string_remove.push('page_url');
            }

            if (filter_portal_visible && filter_portal_visible.val.length) {
                query_string_add.portal_visible = filter_portal_visible.val;
                search_data.portal_visible = filter_portal_visible.val;
            } else {
                query_string_remove.push('portal_visible');
            }

            if (filter_vote_count && filter_vote_count.val.length) {
                query_string_add.vote_count = filter_vote_count.val;
                search_data.vote_count = filter_vote_count.val;
            } else {
                query_string_remove.push('vote_count');
            }

            if (filter_watch_list && filter_watch_list.val.length) {
                query_string_add.watch_list = filter_watch_list.val;
                search_data.watch_list = filter_watch_list.val;
            } else {
                query_string_remove.push('watch_list');
            }

            if (filter_due_date && filter_due_date.val) {
                query_string_add.due_date = filter_due_date.val.join('|');
                search_data.due_date_form = filter_due_date.length > 0 ? filter_due_date.val[0]: '';
                search_data.due_date_to = filter_due_date.length > 1 ? filter_due_date.val[1]: '';
            } else {
                query_string_remove.push('due_date');
            }

            if (filter_sentiment && filter_sentiment.val.length) {
                query_string_add.sentiment = filter_sentiment.val;
                search_data.sentiment = filter_sentiment.val;
            } else {
                query_string_remove.push('sentiment');
            }

            if (filter_action_required && filter_action_required.val.length) {
                query_string_add.action_required = filter_action_required.val;
                search_data.action_required = filter_action_required.val;
            } else {
                query_string_remove.push('action_required');
            }

            if (filter_empty_description && filter_empty_description.val.length) {
                query_string_add.empty_description = filter_empty_description.val;
                search_data.empty_description = filter_empty_description.val;
            } else {
                query_string_remove.push('empty_description');
            }

            Router.addMultipleQueryString(query_string_add, {trigger: false});
            Router.removeQueryString(query_string_remove, {trigger: false});

            this.trigger('search_submit', search_data);
        },

        selectFilter: function(e) {
            $(e.currentTarget).hide();

            var filter_key = $(e.currentTarget).data('val');

            var option = {
                key : filter_key,
                val : this.filters_multiple.indexOf(filter_key) === -1 ? '' : []
            };

            this.filters_selected.push(option);

            $(this.getFilterRow(option)).appendTo(this.$el.find('.region-advanced-filters'));

            if (filter_key === 'due_date') {
                this.$el.find('.filter-item:last').find('input[name="due_date_from"]').focus();
            } else {
                this.$el.find('.filter-item:last').find('input').focus();
            }

            this.setFilterSize();
        },

        deleteFilter: function(e) {
            var item_row   = $(e.currentTarget).parents('.filter-item');
            var filter_key = item_row.data('val');
            var index_del  = 0;

            this.filters_selected.forEach(function(option, index) {
                if (option.key === filter_key) {
                    index_del = index
                }
            });

            this.filters_selected.splice(index_del, 1);

            this.$el.find('.dropdown-filter li[data-val="' + filter_key + '"]').show();

            // for search ui not to close
            setTimeout(function() {
                item_row.remove();
            });
        },

        selectFilterOption: function(e) {
            e.stopPropagation();

            var search_val = $(e.currentTarget).data('val').toString();
            var filter_key = $(e.currentTarget).parents('.filter-item').data('val');
            var radio = $(e.currentTarget).parent().hasClass('dropdown-select-single');

            var filter_option = this.searchFilter(filter_key);

            if (radio) {
                filter_option.val = [search_val];

                $(e.currentTarget).parents('.filter-item').find('ul.dropdown li').removeClass('selected');
                $(e.currentTarget).addClass('selected');
            } else {
                if (filter_option.val.indexOf(search_val) === -1) {
                    filter_option.val.push(search_val);
                } else {
                    filter_option.val.splice(filter_option.val.indexOf(search_val), 1);
                }

                $(e.currentTarget).toggleClass('selected');
            }

            var selected_options = [];

            $(e.currentTarget).parents('.filter-item').find('ul.dropdown li.selected').each(function() {
                selected_options.push($(this).text());
            });

            var btn_html = selected_options.length ? selected_options.join(', ') : 'Select';

            if (filter_key === 'portal_visible') {
                btn_html = selected_options.length ? selected_options.indexOf('Yes') !== -1 ? '<i class="far fa-eye fa-fw text-small text-info"></i><span>Yes</span>' : '<i class="far fa-eye-slash fa-fw text-small text-info"></i><span>No</span>' : 'Select';
            }

            if (filter_key === 'watch_list') {
                btn_html = selected_options.length ? selected_options.indexOf('Yes') !== -1 ? '<span>Yes</span>' : '<span>No</span>' : 'Select';
            }

            $(e.currentTarget).parents('.button-dropdown').children('button').html(btn_html);
        },

        enterFilterOption: function(e) {
            var search_val = $(e.currentTarget).val().trim();
            var filter_key = $(e.currentTarget).parents('.filter-item').data('val');

            if (filter_key === 'due_date') {
                // get input name
                var due_date_to_value = $(e.currentTarget).parents('.filter-item').find('input[name="due_date_to"]').val().trim();
                var due_date_from_value = $(e.currentTarget).parents('.filter-item').find('input[name="due_date_from"]').val().trim();

                search_val = [due_date_from_value, due_date_to_value];
            }

            var filter_option = this.searchFilter(filter_key);

            if (filter_option) {
                filter_option.val = search_val;
            }
        },
    },

    searchFilter: function(key) {
        var result = null;
        this.filters_selected.forEach(function(option) {
            if (option.key === key) {
                result = option;
            }
        });

        return result;
    },

    removeFilter: function(key) {
        var result;

        this.filters_selected.forEach(function(option, index) {
            if (option.key === key) {
                result = index;
            }
        });

        if (typeof result !== 'undefined') {
            this.filters_selected.splice(result, 1);
        }
    },

    addFilterToForm: function(form_data) {
        _.each(form_data, function(val, key) {
            if ((Array.isArray(val) && !val.length) || val === '') {
                // remove filter
                this.removeFilter(key);
            } else {
                // add filter
                if (this.filters.indexOf(key) !== -1) {
                    var filter = this.searchFilter(key);

                    if (filter) {
                        if (key === 'due_date') {
                            filter.val = val.split('|');
                        } else {
                            filter.val = val;
                        }
                    } else {
                        if (key === 'due_date') {
                            this.filters_selected.push({
                                key: key,
                                val: val.split('|')
                            });
                        } else {
                            this.filters_selected.push({
                                key: key,
                                val: val
                            });
                        }
                    }
                }
            }
        }.bind(this));

        Form.setData(this.$el, form_data);
        this.renderFilterOptions();
    },

    searchSuccess: function(response, load_more) {
        Cache.feedback.workflow_count = response.workflow_count;

        Cache.feedback.search_count = response.count;

        // unsubcribed emails
        var feedback_unsubscribed_emails = typeof Cache.get('feedback_unsubscribed_emails') === 'object' ?  Cache.get('feedback_unsubscribed_emails') : {};
        Cache.add('feedback_unsubscribed_emails', {
            ...feedback_unsubscribed_emails,
            ...response.feedback_unsubscribed_emails
        }, false);

        if (load_more) {
            Cache.feedback_comment.add(response.feedback_comment);
            Cache.feedback_screenshot.add(response.feedback_screenshot);
            Cache.feedback_approver.add(response.feedback_approver);
            Cache.feedback_watch_list.add(response.feedback_watch_list);

            Cache.feedback.setSortBy(this.sort_type, this.sort_order);
            Cache.feedback.add(response.feedback);
        } else {
            Cache.feedback_comment.reset(response.feedback_comment);
            Cache.feedback_screenshot.reset(response.feedback_screenshot);
            Cache.feedback_approver.reset(response.feedback_approver);
            Cache.feedback_watch_list.reset(response.feedback_watch_list);

            Cache.feedback.setSortBy(this.sort_type, this.sort_order);
            Cache.feedback.reset(response.feedback);
        }

        this.$el.find('.reset-search').toggle(this.hasSearch());
        this.renderFilters();
        this.renderFilterOptions();
    },

    doSearch: function(form_data, set_form_data, page, sort_type, sort_order, load_more, on_conmplete) {
        if (set_form_data) {
            this.addFilterToForm(form_data);
            this.renderFilters();
        }

        if (page) {
            this.page = page;
        }

        if (sort_type) {
            this.sort_type = sort_type;
        }

        if (sort_order) {
            this.sort_order = sort_order;
        }

        var search_data = _.extend({}, form_data);

        if (search_data.portal_visible && search_data.portal_visible.length) {
            search_data.portal_visible = search_data.portal_visible[0];
        }

        if (search_data.empty_description && search_data.empty_description.length) {
            search_data.empty_description = search_data.empty_description[0];
        }

        if (search_data.watch_list && search_data.watch_list.length) {
            search_data.watch_list = search_data.watch_list[0];
        }

        if (search_data.action_required && search_data.action_required.length) {
            search_data.action_required = search_data.action_required[0];
        }

        this.trigger('search_start', search_data);

        // search is handled by the feedback_board view internally
        if (this.view_type !== 'board') {
            var xhr = Cache.app.request({
                action: 'feedback/search',
                data: _.extend({
                    page              : this.page,
                    sort_type         : this.sort_type,
                    sort_order        : this.sort_order,
                    limit             : this.limit,
                    type              : this.is_design ? 'design' : 'web',
                }, search_data),
                success: (response) => {
                    this.searchSuccess(response, load_more);
                },
                complete: () => {
                    this.trigger('search_complete');

                    if (on_conmplete) {
                        on_conmplete();
                    }
                }
            });

            return xhr;
        }
    },

    clearSearch: function(sort_type, sort_order, search_string) {
        var query_string_remove = ['type', 'assignee', 'priority', 'category', 'workflow', 'segment', 'include_merged', 'search', 'source', 'from', 'to', 'reporter', 'rating', 'page_url', 'page', 'portal_visible', 'vote_count', 'user_property', 'watch_list', 'due_date', 'due_date_to', 'sentiment', 'action_required'];

        Router.removeQueryString(query_string_remove, {triger: false});

        Form.setData(this.$el, {
            search   : search_string || '',
            from     : '',
            to       : ''
        });

        this.filters_selected = [];
        this.renderFilters();
        this.renderFilterOptions();
        this.$el.find('input[type="checkbox"]').prop('checked', false);

        this.page       = 1;
        this.sort_type  = sort_type;
        this.sort_order = sort_order;

        this.trigger('search_start', {});

        if (this.view_type !== 'board') {
            Cache.app.request({
                action: 'feedback/search',
                context: this,
                data: {
                    page           : this.page,
                    sort_type      : this.sort_type,
                    sort_order     : this.sort_order,
                    limit          : this.limit,
                    search         : search_string || '',
                    type           : this.is_design ? 'design' : 'web',
                    include_merged : false
                },
                success: function(response) {
                    this.searchSuccess(response);
                },
                complete: function() {
                    this.trigger('search_complete');
                }
            });
        }
    },

    hasSearch: function() {
        if (this.$el.find('.filter-item:visible').length) {
            return true;
        } else {
            var form_data = Form.getData(this.$el);

            if (form_data.search || form_data.from || form_data.to) {
                return true;
            }
        }

        return false;
    },

    initialize: function(options) {
        this.listenTo(this, 'open', this.setFilterSize);

        this.limit      = options.limit      || 30;
        this.page       = options.page       || 1;
        this.sort_type  = options.sort_type  || 'create';
        this.sort_order = options.sort_order || 'desc';

        this.view_type = options.view_type;
        this.groupby   = options.groupby;
        this.is_design = !!options.is_design;

        // search options built-in
        this.filters_selected = [];
        this.filters = ['source', 'rating', 'reporter', 'page_url', 'portal_visible', 'vote_count', 'watch_list', 'due_date', 'sentiment', 'action_required', 'empty_description'];
    },

    getFilterName: function(key) {
        var translation = {
            source            : 'Source',
            rating            : 'Rating',
            reporter          : 'Reporter',
            page_url          : 'Page URL',
            portal_visible    : 'Portal Visibility',
            vote_count        : 'Vote Count',
            watch_list        : 'Following',
            due_date          : 'Due date',
            sentiment         : 'User Sentiment',
            action_required   : 'Awaiting Response',
            empty_description : 'Empty Description',
        };

        return translation[key];
    },

    getFilterRow: function(option) {
        var search_input = '';
        var operator = 'is';

        switch (option.key) {
            case 'source':
                var source_selected = [];

                option.val.forEach(function(source) {
                    source_selected.push(Util.cap(source));
                });

                search_input +=
                '<div class="button-dropdown button-dropdown-left" data-append="true">' +
                    '<button type="button">' + (Util.htmlEntities(source_selected.join(', ')) || 'Select') + '</button>' +
                    '<div>' +
                        '<ul class="dropdown dropdown-select">' +
                            '<li data-val="widget"'             + (option.val.indexOf('widget')             === -1 ? '' : ' class="selected"') + '>Widget & Extension</li>' +
                            '<li data-val="portal"'             + (option.val.indexOf('portal')             === -1 ? '' : ' class="selected"') + '>Ideas Portal</li>' +
                            '<li data-val="manual"'             + (option.val.indexOf('manual')             === -1 ? '' : ' class="selected"') + '>Manual Upload</li>' +
                            '<li data-val="csv"'                + (option.val.indexOf('csv')                === -1 ? '' : ' class="selected"') + '>CSV Upload</li>' +
                            '<li data-val="api"'                + (option.val.indexOf('api')                === -1 ? '' : ' class="selected"') + '>API</li>' +
                            '<li data-val="intercom_messenger"' + (option.val.indexOf('intercom_messenger') === -1 ? '' : ' class="selected"') + '>Intercom Messenger</li>' +
                            '<li data-val="email"'              + (option.val.indexOf('email')              === -1 ? '' : ' class="selected"') + '>Email</li>' +
                        '</ul>' +
                    '</div>' +
                '</div>';


                break;

            case 'rating':
                var rating_selected = [];

                option.val.forEach(function(rating) {
                    rating_selected.push(Util.cap(rating));
                });

                search_input +=
                '<div class="button-dropdown button-dropdown-left" data-append="true">' +
                    '<button type="button">' + (Util.htmlEntities(rating_selected.join(', ')) || 'Select') + '</button>' +
                    '<div>' +
                        '<ul class="dropdown dropdown-select">' +
                            '<li data-val="1"'    + (option.val.indexOf('1')    === -1 ? '' : ' class="selected"') + '>1</li>' +
                            '<li data-val="2"'    + (option.val.indexOf('2')    === -1 ? '' : ' class="selected"') + '>2</li>' +
                            '<li data-val="3"'    + (option.val.indexOf('3')    === -1 ? '' : ' class="selected"') + '>3</li>' +
                            '<li data-val="4"'    + (option.val.indexOf('4')    === -1 ? '' : ' class="selected"') + '>4</li>' +
                            '<li data-val="5"'    + (option.val.indexOf('5')    === -1 ? '' : ' class="selected"') + '>5</li>' +
                            '<li data-val="up"'   + (option.val.indexOf('up')   === -1 ? '' : ' class="selected"') + '>Up</li>' +
                            '<li data-val="down"' + (option.val.indexOf('down') === -1 ? '' : ' class="selected"') + '>Down</li>' +
                        '</ul>' +
                    '</div>' +
                '</div>';

                break;
            case 'reporter':
                var reporter_options = '';

                Cache.app.getUsersByProject(Cache.default_project_id, [Constants.ADMIN, Constants.ASSIGNEE]).forEach(function(user) {
                    reporter_options += '<li data-val="' + user.id + '"' + (option.val.indexOf(user.id) === -1 ? '' : ' class="selected"') + '>' + user.escape('name') + '</li>';
                });

                var reporter_names = [];

                option.val.forEach(function(user_id) {
                    if (Cache.user.get(user_id)) {
                        reporter_names.push(Cache.user.get(user_id).get('name'));
                    }
                });

                search_input +=
                '<div class="button-dropdown button-dropdown-left" data-append="true">' +
                '<button type="button">' + (Util.htmlEntities(reporter_names.join(', ')) || 'Select') + '</button>' +
                    '<div>' +
                        '<ul class="dropdown dropdown-select">' + reporter_options + '</ul>' +
                    '</div>' +
                '</div>';

                break;

            case 'portal_visible':
                var portal_visible_selected = [];

                option.val.forEach(function(portal_visible) {
                    portal_visible_selected.push(portal_visible);
                });

                search_input +=
                '<div class="button-dropdown button-dropdown-left" data-append="true">' +
                    '<button class="portal-visible-select" type="button">' + (option.val.length ? option.val[0] === 1 ? '<i class="far fa-eye fa-fw text-small text-info"></i><span>Yes</span>' : '<i class="far fa-eye-slash fa-fw text-small text-info"></i><span>No</span>' : 'Select') + '</button>' +
                    '<div>' +
                        '<ul class="dropdown dropdown-select dropdown-select-single">' +
                            '<li class="' + (portal_visible_selected[0] === 1 ? 'selected' : '') + '" data-val="1">Yes</li>' +
                            '<li class="' + (portal_visible_selected[0] === 0 ? 'selected' : '') + '" data-val="0">No</li>' +
                        '</ul>' +
                    '</div>' +
                '</div>';

                break;

            case 'vote_count':
                search_input +=
                    '<div class="number-input">' +
                        '<input type="text" min="0" value="' + (option.val && option.val[0] ? option.val[0] : '') + '">' +
                        '<button class="number-input-minus" type="button"><i class="far fa-minus"></i></button>' +
                        '<button class="number-input-plus" type="button"><i class="far fa-plus"></i></button>' +
                    '</div>';
                ;

                operator = 'is greater than';

                break;
            case 'watch_list':
                var watch_list_visible_selected = [];

                option.val.forEach(function(watch_list_visible) {
                    watch_list_visible_selected.push(watch_list_visible);
                });

                search_input +=
                '<div class="button-dropdown button-dropdown-left" data-append="true">' +
                    '<button class="watch-list-select" type="button">' + (option.val.length ? option.val[0] === 1 ? '<span>Yes</span>' : '<span>No</span>' : 'Select') + '</button>' +
                    '<div>' +
                        '<ul class="dropdown dropdown-select dropdown-select-single">' +
                            '<li class="' + (watch_list_visible_selected[0] === 1 ? 'selected' : '') + '" data-val="1">Yes</li>' +
                            '<li class="' + (watch_list_visible_selected[0] === 0 ? 'selected' : '') + '" data-val="0">No</li>' +
                        '</ul>' +
                    '</div>' +
                '</div>';
                break;
            case 'due_date':
                // split due date to from and to
                var due_dates = option.val;
                var due_date_from = due_dates.length > 0 ? due_dates[0]: '';
                var due_date_to = due_dates.length > 1 ? due_dates[1]: '';
                search_input += '<div>';
                search_input += 'From: <input type="date" class="medium" name="due_date_from" value="' + Util.htmlEntities(due_date_from) + '">';
                search_input += 'To: <input type="date" class="medium" name="due_date_to" value="' + Util.htmlEntities(due_date_to) + '">';
                search_input += '</div>';
                operator = '';
                break;
            case 'sentiment':
                var sentiment_selected = [];

                option.val.forEach(function(sentiment) {
                    var sentimentMap = {
                        '1': 'Negative',
                        '2': 'Neutral',
                        '3': 'Positive',
                        '0': 'Unknown',
                    };

                    if (sentimentMap[sentiment]) {
                        sentiment_selected.push(sentimentMap[sentiment]);
                    }
                });

                search_input +=
                '<div class="button-dropdown button-dropdown-left" data-append="true">' +
                    '<button class="sentiment-select" type="button">' + (Util.htmlEntities(sentiment_selected.join(', ')) || 'Select') + '</button>' +

                    '<div>' +
                        '<ul class="dropdown dropdown-select">' +
                            '<li class="' + (sentiment_selected.includes('Negative') ? 'selected' : '') + '" data-val="1">Negative</li>' +
                            '<li class="' + (sentiment_selected.includes('Neutral') ? 'selected' : '') + '" data-val="2">Neutral</li>' +
                            '<li class="' + (sentiment_selected.includes('Positive') ? 'selected' : '') + '" data-val="3">Positive</li>' +
                            '<li class="' + (sentiment_selected.includes('Unknown') ? 'selected' : '') + '" data-val="0">Unknown</li>' +
                        '</ul>' +
                    '</div>' +
                '</div>';
                break;
            case 'action_required':
                var action_required_selected = [];

                option.val.forEach(function(action_required) {
                    action_required_selected.push(action_required);
                });

                search_input +=
                '<div class="button-dropdown button-dropdown-left" data-append="true">' +
                    '<button class="action-required-select" type="button">' + (option.val.length ? option.val[0] === 1 ? '<span>Yes</span>' : '<span>No</span>' : 'Select') + '</button>' +
                    '<div>' +
                        '<ul class="dropdown dropdown-select dropdown-select-single">' +
                            '<li class="' + (action_required_selected[0] === 1 ? 'selected' : '') + '" data-val="1">Yes</li>' +
                            '<li class="' + (action_required_selected[0] === 0 ? 'selected' : '') + '" data-val="0">No</li>' +
                        '</ul>' +
                    '</div>' +
                '</div>';

                break;

            case 'empty_description':
                var description_selected = [];
                option.val.forEach(function(empty_description) {
                    description_selected.push(empty_description);
                });

                // is empty or is not empty
                search_input = '<div class="button-dropdown button-dropdown-left" data-append="true">' +
                    '<button class="action-required-select" type="button">' + (option.val.length ? option.val[0] === 1 ? '<span>Yes</span>' : '<span>No</span>' : 'Select') + '</button>' +
                    '<div>' +
                        '<ul class="dropdown dropdown-select dropdown-select-single">' +
                            '<li class="' + (description_selected[0] === 1 ? 'selected' : '') + '" data-val="1">Yes</li>' +
                            '<li class="' + (description_selected[0] === 0 ? 'selected' : '') + '" data-val="0">No</li>' +
                        '</ul>' +
                    '</div>' +
                '</div>';
                break;

            default:
                search_input = '<input type="text" value="' + Util.htmlEntities(option.val) + '">';
                operator = 'contains';
                break;
        }

        return '<div class="filter-item" data-val="' + Util.htmlEntities(option.key) + '">' +
                    '<div class="search-key">' +
                        '<span class="search-key-val">' + this.getFilterName(option.key) + '</span>' +
                        '<span>' + operator + '</span>' +
                    '</div>' +
                    '<div class="search-val">' + search_input + '</div>' +
                    '<div class="search-del">' +
                        '<button type="button" class="small text-info"><i class="fa-solid fa-trash"></i></button>' +
                    '</div>' +
                '</div>';
    },

    renderFilters: function() {
        var html = '';
        this.filters_selected.forEach((option) => {
            html += this.getFilterRow(option);
        });

        this.$el.find('.region-advanced-filters').html(html);

        this.setFilterSize();
    },

    setFilterSize: function() {
        this.$el.find('.filter-item').each(function() {
            $(this).find('.search-val').width($(this).outerWidth() - $(this).find('.search-key').outerWidth() - 2); // 2 half pixel issue
        });
    },

    renderFilterOptions: function() {
        var options =
        '<li data-val="rating"'   + (this.searchFilter('rating')   ? ' style="display:none;"' : '') + '>Rating</li>' +
        '<li data-val="reporter"' + (this.searchFilter('reporter') ? ' style="display:none;"' : '') + '>Reporter</li>' +
        '<li data-val="source"'   + (this.searchFilter('source')   ? ' style="display:none;"' : '') + '>Source</li>' +
        '<li data-val="page_url"' + (this.searchFilter('page_url') ? ' style="display:none;"' : '') + '>Page URL</li>' +
        (Cache.account.hasFeature('portal') ?
        '<li data-val="portal_visible"' + (this.searchFilter('portal_visible') ? ' style="display:none;"' : '') + '>Portal Visibility</li>' : '') +
        '<li data-val="vote_count"' + (this.searchFilter('vote_count') ? ' style="display:none;"' : '') + '>Vote Count</li>' +
        '<li data-val="watch_list"' + (this.searchFilter('watch_list') ? ' style="display:none;"' : '') + '>Following</li>' +
        '<li data-val="due_date"' + (this.searchFilter('due_date') ? ' style="display:none;"' : '') + '>Due Date</li>'+
        '<li data-val="sentiment"' + (this.searchFilter('sentiment') ? ' style="display:none;"' : '') + '>User Sentiment</li>' +
        '<li data-val="action_required"' + (this.searchFilter('action_required') ? ' style="display:none;"' : '') + '>Awaiting Response</li>' +
        '<li data-val="empty_description"' + (this.searchFilter('empty_description') ? ' style="display:none;"' : '') + '>Empty Description</li>';

        this.$el.find('.dropdown-filter').html(options);
    },

    render: function() {
        var content = '';

        content += '<input type="hidden" name="search">' +
                    '<div class="form-fluid">' +
                        '<div class="grid-6-6">' +
                            '<div class="margin-right-4">' +
                                '<div class="field-label">Created from</div>' +
                                '<input type="date" class="solid medium" name="from">' +
                            '</div>' +
                            '<div class="margin-left-4">' +
                                '<div class="field-label">To</div>' +
                                '<input type="date" class="solid medium" name="to">' +
                            '</div>' +
                        '</div>' +
                        '<div class="margin-top-8 text-medium">' +
                            '<a href="#" class="date-shortcut" data-shortcut="today">Today</a>' +
                            '<a href="#" class="date-shortcut" data-shortcut="week">This Week</a>' +
                            '<a href="#" class="date-shortcut" data-shortcut="month">This Month</a>' +
                            '<a href="#" class="date-shortcut" data-shortcut="year">This Year</a>' +
                            '<a href="#" class="date-shortcut" data-shortcut="all">All Time</a>' +
                        '</div>' +
                    '</div>' +

                    '<div>' +
                        '<div class="region-advanced-filters"></div>' +
                        '<div class="button-dropdown button-dropdown-left" data-append="true">' +
                            '<button type="button" class="tertiary small"><i class="far fa-plus"></i> Add filter</button>' +
                            '<div>' +
                                '<ul class="dropdown dropdown-medium dropdown-filter"></ul>' +
                            '</div>' +
                        '</div>' +
                    '</div>' +

                    '<div class="margin-top-30 margin-bottom-0">' +
                        '<button class="primary medium">Search</button>' +
                        '<a href="#" class="cancel reset-search" style="display:none;">Clear search</a>' +
                    '</div>';

        this.$el.html(content);

        if (!this.is_design) {
            this.renderFilters();
            this.renderFilterOptions();
        }

        return this;
    }
});